var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var classNames = require('classnames');

var Option = require('./Option');

function stringifyValue (value) {
	if (typeof value === 'object') {
		return JSON.stringify(value);
	} else {
		return value;
	}
}

var stringOrNode = PropTypes.oneOfType([
	PropTypes.string,
	PropTypes.node
]);

var Select = createReactClass({
	propTypes: {
		className: PropTypes.string,          // className for the outer element
		delimiter: PropTypes.string,          // delimiter to use to join multiple values for the hidden field value
		disabled: PropTypes.bool,             // whether the Select is disabled or not
		inputProps: PropTypes.object,         // custom attributes for the Input		
		isLoading: PropTypes.bool,            // whether the Select is loading externally or not (such as options being loaded)
		labelKey: PropTypes.string,           // path of the label value in option objects		
		name: PropTypes.string,               // generates a hidden <input /> tag with this field name for html forms
		onFocus: PropTypes.func,              // onFocus handler: function (event) {}		
		options: PropTypes.array,             // array of options
		placeholder: stringOrNode,                  // field placeholder, displayed when there's no value
		required: PropTypes.bool,             // applies HTML5 required attribute when needed
		style: PropTypes.object,              // optional style to apply to the control
		tabIndex: PropTypes.string,           // optional tab index of the control
		value: PropTypes.any,                 // initial field value
		valueKey: PropTypes.string,           // path of the label value in option objects
	},

	getDefaultProps () {
		return {
			delimiter: ',',
			disabled: false,
			inputProps: {},
			isLoading: false,
			labelKey: 'label',
			onBlurResetsInput: true,
			optionComponent: Option,
			placeholder: 'Select',
			required: false,
			scrollMenuIntoView: false,
			valueKey: 'value',
		};
	},	

	getInitialState () {
		return {
			inputValue: '',
			isFocused: false,
			isLoading: false,
			isOpen: false,
			isPseudoFocused: false,
			required: this.props.required
		};
	},

	componentWillUpdate (nextProps, nextState) {
		if (nextState.isOpen !== this.state.isOpen) {
			var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
			handler && handler();
		}
	},

	componentDidUpdate (prevProps, prevState) {
		if (prevState.inputValue !== this.state.inputValue && this.props.onInputChange) {
			this.props.onInputChange(this.state.inputValue);
		}

		if (prevProps.disabled !== this.props.disabled) {
			this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
		}
	},

	focus() {
		if (!this.refs.input) return;
		this.refs.input.focus();

		this.setState({
			isOpen: true,
		});
	},

	blurInput() {
		if (!this.refs.input) return;
		this.refs.input.blur();
	},	

	focusOption (option) {
		this.setState({
			focusedOption: option
		});
	},	

	handleMouseDown (event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || (event.type === 'mousedown' && event.button !== 0)) {
			return;
		}

		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();

		this.focus();
		return this.setState({
			isOpen: !this.state.isOpen,
		});

	},

	handleMouseDownOnArrow (event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || (event.type === 'mousedown' && event.button !== 0)) {
			return;
		}
		// If the menu isn't open, let the event bubble to the main handleMouseDown
		if (!this.state.isOpen) {
			return;
		}
		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();
		// close the menu
		this.closeMenu();
	},

	handleMouseDownOnMenu (event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || (event.type === 'mousedown' && event.button !== 0)) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();

		this._openAfterFocus = true;
		this.focus();
	},

	handleInputChange (event) {
		this.setState({
			isOpen: true,
			isPseudoFocused: false,
			inputValue: event.target.value,
		});
	},

	handleInputFocus (event) {
		var isOpen = this.state.isOpen || this._openAfterFocus;
		if (this.props.onFocus) {
			this.props.onFocus(event);
		}
		this.setState({
			isFocused: true,
			isOpen: isOpen
		});
		this._openAfterFocus = false;
	},	

	handleInputBlur (event) {
		if (this.refs.menu && document.activeElement === this.refs.menu) {
			this.focus();
			return;
		}

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
		var onBlurredState = {
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
		};

		this.setState(onBlurredState);
	},

	setValue (value) {
		if (!this.props.onChange) return;
		if (this.props.required) {
			var required = this.handleRequired(value, this.props.multi);
			this.setState({ required });
		}

		if (value) {
			value = value.map(i => i[this.props.valueKey]).join(this.props.delimiter);
		}
		this.props.onChange(value);
	},	

	selectValue (value) {
		this.hasScrolledToOption = false;
		var valueArray = this.getValueArray();
		
		if (valueArray.indexOf(value) > -1) {
			this.removeValue(value);
		} else {
			this.addValue(value);			
		}
		
		this.setState({
			inputValue: '',
		});

		this.focus();
	},

	addValue (value) {
		var valueArray = this.getValueArray();
		this.setValue(valueArray.concat(value));
	},

	removeValue (value) {
		var valueArray = this.getValueArray();
		this.setValue(valueArray.filter(i => i !== value));
		this.focus();
	},	

	closeMenu () {
		this.setState({
			isOpen: false,
			isPseudoFocused: this.state.isFocused && !this.props.multi,
			inputValue: '',
		});
		this.hasScrolledToOption = false;
	},	

	getValueArray () {
		var value = this.props.value;
		if (typeof value === 'string') value = value.split(this.props.delimiter);
		if (!Array.isArray(value)) {
			if (value === null || value === undefined) return [];
			value = [value];
		}
		return value.map(this.expandValue).filter(i => i);
	},

	expandValue (value) {
		if (typeof value !== 'string' && typeof value !== 'number') return value;
		var options = this.props.options;
		var valueKey = this.props.valueKey;
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (options[i][valueKey].toLowerCase() === value.toLowerCase()) return options[i];
		}
	},

	getFocusableOption (selectedOption) {
		var options = this._visibleOptions;
		if (!options.length) return;
		var focusedOption = this.state.focusedOption || selectedOption; 
		if (focusedOption && options.indexOf(focusedOption) > -1) return focusedOption;
		for (var i = 0; i < options.length; i++) {
			if (!options[i].disabled) return options[i];
		}
	},

	renderMenu: function (options, valueArray, focusedOption) {
		if (options && options.length) {
			return options.map((option, i) => {
				var isSelected = valueArray && valueArray.indexOf(option) > -1;
				var isFocused = option === focusedOption;
				var optionRef = isFocused ? 'focused' : null;
				var optionClass = classNames({
					'multiselect-option': true,
					'is-selected': isSelected,
					'is-focused': isFocused,
					'is-disabled': option.disabled
				});

				return (
					<Option className={optionClass}
						isDisabled={option.disabled}
						isFocused={isFocused}
						key={`option-${i}-${option[this.props.valueKey]}`}
						onSelect={this.selectValue}
						onFocus={this.focusOption}
						option={option}
						isSelected={isSelected}
						checkboxName={this.props.name}
						ref={optionRef}
						onChange={this.handleInputChange}
						valueKey={this.props.valueKey}
						labelKey={this.props.labelKey}
					/>
				);
			});
		} else if (this.props.noResultsText) {
			return (
				<div className="multiselect-noresults">{this.props.noResultsText}</div>
				);
		} else {
			return null;
		}
	},

	renderArrow: function() {
		return (
			<span className="multiselect-arrow-zone" onMouseDown={this.handleMouseDownOnArrow}>
				<span className="multiselect-arrow" onMouseDown={this.handleMouseDownOnArrow} />
			</span>
		);
	},

	renderValue: function (valueArray) {
		if (!valueArray.length) {
			return !this.state.inputValue ? <div className="multiselect-placeholder">{this.props.placeholder}</div> : null;
		}

		if(valueArray.length === 1) {
			return (
				<div className="multiselect-value">{this.renderLabel(valueArray[0])}</div>
			);
		} else {
			return (
				<div className="multiselect-value">{valueArray.length} selected</div>
			);
		}
	},	

	renderHiddenField (valueArray) {
		if (!this.props.name) return;
		if (this.props.joinValues) {
			var value = valueArray.map(i => stringifyValue(i[this.props.valueKey])).join(this.props.delimiter);
			return (
				<input
					type="hidden"
					ref="value"
					name={this.props.name}
					value={value}
					disabled={this.props.disabled} />
			);
		}

		return valueArray.map((item, index) => (
			<input key={'hidden.' + index}
				type="hidden"
				ref={'value' + index}
				name={this.props.name}
				value={stringifyValue(item[this.props.valueKey])}
				disabled={this.props.disabled} />
		));
	},	

	renderOuter(options, valueArray, focusedOption) {
		return (
			<div ref="menuContainer" className="multiselect-menu-outer" style={this.props.menuContainerStyle}>
				<div ref="menu" className="multiselect-menu"
					style={this.props.menuStyle}
					onScroll={this.handleMenuScroll}
					onMouseDown={this.handleMouseDownOnMenu}>
					{this.renderMenu(options, valueArray, focusedOption)}
				</div>
			</div>
		);
	},

	blockEvent (event) {
		event.stopPropagation();
		event.preventDefault();
		return;
	},

	renderInput () {
		return (
			<div>
				<button
					ref="input"
					tabIndex="0"
					onBlur={this.handleInputBlur}
					onClick={this.blockEvent}
					style={{ border: 0, width:2, height:2, display:'inline-block', outline:'none'}}/>
			</div>
		);
	},

	renderLabel(option) {
		return option[this.props.labelKey];
	},

	 render() {
	 	var valueArray = this.getValueArray();
	 	var options = this._visibleOptions = this.props.options;
	 	var isOpen = this.state.isOpen;
	 	var focusedOption = this._focusedOption = this.getFocusableOption(valueArray[0]);
		var className = classNames('multiselect', this.props.className, {
			'is-disabled': this.props.disabled,
			'is-focused': this.state.isFocused,
			'is-loading': this.props.isLoading,
			'is-open': isOpen,
			'is-pseudo-focused': this.state.isPseudoFocused,
			'has-value': valueArray.length,
		});

		return (
			<div ref="wrapper" className={className} style={this.props.wrapperStyle}>
				{this.renderHiddenField(valueArray)}
				<div ref="control"
						 className="multiselect-control"
						 style={this.props.style}
						 onKeyDown={this.handleKeyDown}
						 onMouseDown={this.handleMouseDown}>
					{this.renderValue(valueArray)}
					{this.renderInput()}
					{this.renderArrow()}
				</div>
				{isOpen ? this.renderOuter(options, valueArray, focusedOption): null}
			</div>
		);
	}
});

module.exports = Select;